import { Button, ButtonProps } from "@material-ui/core";

import { useStyles } from "./InputButton.style";

export function InputButton(props: ButtonProps) {
  const classes = useStyles(props);

  return (
    <Button className={classes.root} disableElevation {...props}>
      {props.children}
    </Button>
  );
}
